// Module
var code = "<div class=\"overlay\" ng-if=\"$root.page.isLoading()\"> <div class=\"top-petal\"></div> <div class=\"middle-petal\"></div> <div class=\"bottom-petal\"></div> </div> ";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Gui/Components/PageLoadingOverlay/PageLoadingOverlay.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;